import { Button, Card, H5, H6 } from "@sellar-io/components";
import { formatCurrency } from "@sellar-io/common";
import { ReactElement } from "react";
import { Icon } from "../../../../../components";
import {
  SellarContextActionEnum,
  useSellarContext,
} from "../../../../../hooks";

export const StorefrontBasketSummaryCard = ({
  orderTotal,
  orderSubtotal,
  orderItems,
  orderCurrency,
}: {
  orderTotal: number;
  orderSubtotal: number;
  orderItems: { quantity: number }[];
  orderCurrency: string;
}): ReactElement | null => {
  const [{}, dispatch] = useSellarContext();

  const orderItemsLength = orderItems.reduce(
    (acc, obj) => acc + obj.quantity,
    0,
  );

  const totalNbOfItems = orderItemsLength;

  return (
    <Card className="bg-white">
      <div className="flex flex-col">
        <div className="flex justify-between">
          <H6>Subtotal</H6>
          <H6 className={"justify-end"}>
            {formatCurrency(orderSubtotal, orderCurrency)}
          </H6>
        </div>

        <div className="flex justify-between">
          <H5>Total (inc. VAT & charges)</H5>
          <H5 className={"justify-end"}>
            {formatCurrency(orderTotal, orderCurrency)}
          </H5>
        </div>
      </div>
      <Button
        onClick={() => {
          return dispatch({
            type: SellarContextActionEnum.CHANGE_SIDE_PANEL_ACTIVE,
            sidePanelActive: true,
          });
        }}
        disabled={!totalNbOfItems}
        className={"mt-2 w-full"}
      >
        <Icon icon={"CART"} /> View Basket{" "}
        {!!totalNbOfItems && `(${totalNbOfItems})`}
      </Button>
    </Card>
  );
};
